
import {bzApi, platformApi, transMetaboApi} from "@/axios";

export function addTransMetaboProject(data) {
    return transMetaboApi ({
        url: '/projects/add',
        method: 'post',
        data:data
    })
}
export function transMetaboProjectPage(params,data) {
    return transMetaboApi ({
        url: '/projects/page',
        method: 'post',
        params:params,
        data:data
    })
}
export function transMetaboProjectRemarkEdit(id,data) {
    return transMetaboApi ({
        url: '/projects/edit/remark/'+id,
        method: 'put',
        data:data,
        headers: {
            'Content-Type': 'text/plain'
        }
    })
}
export function transMetaboProjectCustomerRemarkEdit(id,data) {
    return transMetaboApi ({
        url: '/projects/edit/customer-remark/'+id,
        method: 'put',
        data:data,
        headers: {
            'Content-Type': 'text/plain'
        }
    })
}
export function transMetaboProjectChangeUser(data) {
    return transMetaboApi ({
        url: '/projects/edit/personnel',
        method: 'put',
        data:data,
    })
}
export function editTransMetaboProject(data) {
    return transMetaboApi({
        url: '/projects/edit',
        method: 'put',
        data: data
    })
}
export function transMetaboProjectDel(ids) {
    return transMetaboApi({
        url: '/projects/' + ids,
        method: 'delete'
    })
}
export function projectLast_10_transMetabo(){
    return transMetaboApi({
        url: '/projects/last-10',
        method: 'post',
        data:{}
    })
}
